/* Just Brilliant: native scrolling with progressively enhanced gallery controls. */
(() => {
  if (customElements.get('jb-related-carousel')) return;
  customElements.define('jb-related-carousel', class extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('ul');
      if (!this.list || this.controller) return;
      this.buttons = [...this.querySelectorAll('[data-direction]')];
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const update = () => this.update();
      this.list.addEventListener('scroll', update, { ...options, passive: true });
      window.addEventListener('resize', update, options);
      this.buttons.forEach(button => button.addEventListener('click', () => {
        const rtl = getComputedStyle(this.list).direction === 'rtl';
        this.list.scrollBy({ left: this.list.clientWidth * Number(button.dataset.direction) * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, options));
      if (typeof ResizeObserver !== 'undefined') {
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.list);
      }
      this.update();
    }
    update() {
      const max = this.list.scrollWidth - this.list.clientWidth;
      const offset = Math.abs(this.list.scrollLeft);
      this.buttons.forEach(button => {
        button.hidden = max <= 1;
        button.disabled = Number(button.dataset.direction) < 0 ? offset <= 1 : offset >= max - 1;
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
    }
  });
})();
